import { MapperConnectionType, MapperConnectionReference } from 'app/model/adfDataMapper/mapperConnectionReference';
import { IModel, LinkedService, Metamodel, Named } from 'shell-models-lib';

@Metamodel.model({
    name: 'MapperConnection'
})
export class MapperConnection extends Named{
    public static readonly MODEL: IModel;
    public readonly type: MapperConnectionType;

    @Metamodel.attribute({
        display: stringResources.LinkedService,
        reference: true,
        type: LinkedService.MODEL
    })
    public linkedService?: LinkedService;
    public linkedServiceType?: string;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private _commonDslConnectorProperties: Map<string, any>;

    constructor(connectionType: MapperConnectionType) {
        super();
        this.type = connectionType;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public get commonDslConnectorProperties(): Map<string, any> {
        if (!this._commonDslConnectorProperties) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this._commonDslConnectorProperties = new Map<string, any>();
        }

        return this._commonDslConnectorProperties;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public set commonDslConnectorProperties(commonDslProperties: Map<string, any>) {
        this._commonDslConnectorProperties = commonDslProperties;
    }

    public getConnectionReference(): MapperConnectionReference {
        if (this.type === MapperConnectionType.LinkedServiceType) {
            return new MapperConnectionReference(this.linkedService?.name, this.type);
        }

        return undefined;
    }

    public isEqualToConnectionReference(connectionReference: MapperConnectionReference): boolean {
        if (!!connectionReference
            && this.linkedService
            && connectionReference.type === this.type
            && connectionReference.connectionName === this.linkedService.name) {
            return true;
        }

        return false;
    }
}
